import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IDevice } from 'src/app/pages/devices/models/device.interface';
import { EOrdenacao } from 'src/app/shared/data/ordenacao.enum';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { DeviceService } from '../../../devices/services/device.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { FilasService } from '../../services/filas.service';

@Component({
  selector: 'app-tab-device',
  templateUrl: './tab-device.component.html',
  styleUrls: ['./tab-device.component.scss']
})
export class TabDevicesComponent implements OnInit{
  ERoleAdminString = ERoleAdminString;
  @Input() dadosPaginacaoDevices = {
    ordenacao: EOrdenacao.AlfabeticaAZ,
    paginaSelecionada: 0,
    tamanhoPagina: 4,
    totalPaginas: 0,
    itensTotal: 0
  };
  @Input() queueDevices: IDevice[] = [];
  @Input() companyId?: string;

  @Output() mudouPagina = new EventEmitter();
  @Output() mudouTamanhoPagina = new EventEmitter();
  @Output() recarregarListagem = new EventEmitter<void>();

  addDeviceOpen = false;

  formGroup = new UntypedFormGroup({
    devicesSelected: new UntypedFormControl([])
  });
  deviceOptions: IDevice[] = [];

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly deviceService: DeviceService,
    private readonly queueService: FilasService
    ) { }

  ngOnInit(): void {
    this.getActivesDevices();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['queueDevices'] && !changes['queueDevices'].firstChange) {
      this.getActivesDevices();
    }
  }

  public abrirEmNovaAba(deviceId: string): void {
    const url = this.router.serializeUrl(this.router.createUrlTree([`/dash/dispositivos/editar/${deviceId}`]));

    window.open(url, '_blank');
  }

  getActivesDevices(): void {
    this.deviceService.getActiveDevicesByCompany(this.companyId!).subscribe((response) => {
      const devices = response.data;

      const devicesFiltered = devices.filter(device => !this.queueDevices.some(queueDevice => queueDevice.id ===  device.id));
      this.deviceOptions = devicesFiltered;
    });
  }

  public addDevices(): void {
    const devicesSelected = this.formGroup.get('devicesSelected')?.value;

    if(devicesSelected.length === 0) return;

    const queueId = this.activatedRoute.snapshot.paramMap.get('id')!;

    this.queueService.addDevicesToQueue(queueId, devicesSelected).subscribe(() => {
      this.updateQueueDevices();
      this.formGroup.reset();
      this.addDeviceOpen = false;
    });
  }

  public removeDevice(deviceId: string): void {
    const queueId = this.activatedRoute.snapshot.paramMap.get('id')!;

    this.queueService.removeDeviceFromQueue(queueId, deviceId).subscribe(() => {
      this.updateQueueDevices();
    });
  }

  public updateQueueDevices(): void {
    this.recarregarListagem.emit();
  }
}
